module.exports = __webpack_public_path__ + "img/eng-sector-navigate.02bf7b42.svg";